let messaages_ko = {
	Salutation: {
		required: '인사말을 선택하세요.',
	},
	FirstName: {
		required: '이름을 입력하십시오.',
	},
	LastName: {
		required: '성을 입력하십시오.',
	},
	Email: {
		required: '이메일 주소를 입력하십시오.',
		email: '유효한 이메일 주소를 입력하십시오.',
	},
	Country: {
		required: '국가를 선택하십시오.',
	},
	Postcode: {
		required: '우편 번호를 선택하십시오.',
	},
	Password: {
		required: '암호를 입력하십시오.',
	},
	ConfirmPassword: {
		required: '확인을 위해 암호를 입력하십시오.',
		equalTo: '암호가 일치하는지 확인하십시오.',
	},
	TermsAndConditions: {
		required: '이용 약관에 동의하십시오.',
	}
};

export function messages_ko() {
	return messaages_ko;
}
